import styles from './Group.module.css';
import '../../resources/css/admin_style.css';
import React, {useContext, useEffect, useState} from "react";
import Loading from "../../utils/loading/Loading";
import {ModalContext} from "../../utils/modal/ModalProvider";
import {IAM_SERVER_SERVICE, IAM_SERVER_SERVICE_GROUP, IAM_SERVER_SERVICE_PAGE, IAM_SERVER_SERVICE_PAGEAUTH} from "../../utils/Config";
import axios from "../../utils/api/axios";
import DetailModal from "../../utils/modal/DetailModal";
import {GroupDetailModal} from "./modal/GroupDetailModal";
import {GroupRegisterModal} from "./modal/GroupRegisterModal";
import {GroupUserRegisterModal} from "./modal/GroupUserRegisterModal";
import { useServiceList } from '../../utils/service/serviceList';
import { useSelectedService } from '../../utils/contextapi/ServiceProvider';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaSearch } from 'react-icons/fa';
import { TableContext } from '../../utils/contextapi/TableProvider';
import GroupUsersTable from './component/GroupUsersTable';
import { InnocodeButton, InnocodeList, useDialog, useInnocodeLoadingOverlay, useModal } from '@intsoft/innocode-core';

/**
 * 페이지 권한 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Group({isMobile, setMovePage}) {
    const { showInnocodeModal } = useModal();
    const {openModal} = useContext(ModalContext);
    const { showDialog } = useDialog();
    const { show: showLoading, hide: hideLoading } = useInnocodeLoadingOverlay();
    const [usersLoading, setUsersLoading] = useState(false);
    const context = useContext(TableContext);
    const [expandedNodes, setExpandedNodes] = useState({}); // 확장된 노드들을 관리

    const [sortModel, setSortModel] = React.useState({
        field: "created_date",   // 현재 정렬 기준값
        sort: "desc",   // (asc: 오름차순, desc: 내림차순)
    });

    const [isMobileWindow, setIsMobileWindow] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    //검색 조건
    const [selectedKind, setSelectedKind] = useState("");
    const [searchValue, setSearchValue] = useState('');

    //테이블 데이터
    const [cellData, setCellData] = useState([]);
    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수
    const [totalCount, setTotalCount] = useState(0);

    const { selectedService } = useSelectedService();

    //페이지 데이터, 선택 페이지
    const [treeData, setTreeData] = useState([]);
    const [showGroupTree, setShowGroupTree] = useState(true);
    const [selectedGroup, setSelectedGroup] = useState(null);

    //선택 페이지 권한 목록
    const [originalGroupUsers, setOriginalGroupUsers] = useState([]); // 최초 서버에서 받아온 권한 리스트(수정 전)
    const [selectedGroupUsers, setSelectedGroupUsers] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    //---- 그룹트리 ----//

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (selectedService) {
            fetchData();
        } 
    }, [selectedService]);

    // 데이터 테이블 조회 API
    const fetchData = async (selectedKey = null) => {
        showLoading();

        try {
            const url = IAM_SERVER_SERVICE_GROUP + "/get/groups/tree?serviceId=" + selectedService.serviceId;
            const res = await axios.get(url);
            const { data } = res.data;
            const transformed = transformToTreeData(data);
            setTreeData(transformed);

            // 기존 선택 그룹을 찾아서 유지 (selectedKey: groupId string)
            let groupToSelect = selectedKey;
            if (!groupToSelect && selectedGroup) {
                groupToSelect = selectedGroup.key;
            }
            if (groupToSelect) {
                // 최신 트리에서 해당 groupId가 있는지 확인
                const findGroup = (nodes) => {
                    for (const node of nodes) {
                        if (node.key === groupToSelect) return node;
                        if (node.children) {
                            const found = findGroup(node.children);
                            if (found) return found;
                        }
                    }
                    return null;
                };

                const found = findGroup(transformed);

                if (found) {
                    setSelectedGroup(found);
                    // 유저 리스트도 새로 조회
                    getGroupUsersAll(found.key);
                } else {
                    setSelectedGroup(null);
                    setSelectedGroupUsers([]);
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            hideLoading();
        }
    }

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.groupName,   // 트리에 표시될 텍스트
            key: item.groupId.toString(), // 고유한 키 (문자열 추천)
            userCount: item.userCount,
            children: item.children ? transformToTreeData(item.children) : []
        }));
    };

    const handleSelect = (node) => {
        setSelectedGroup(node);
        setSelectedGroupUsers([]); // ← 미리 초기화!
        getGroupUsersAll(node.key, 0, listSize);
    };

    const toggleExpand = (nodeKey) => {
        setExpandedNodes(prev => ({
            ...prev,
            [nodeKey]: !prev[nodeKey]
        }));
    };

    const handleDetailClick = (node, e) => {
        e.stopPropagation(); // 그룹 선택 방지
        handleDetailInfo(node);
    };


    const getGroupUsersAll = async (id, page = 0, size = listSize,) => {
        setUsersLoading(true);

        const groupUsersAll = IAM_SERVER_SERVICE_GROUP + "/get/" + id + "/users";

        const params = {
            serviceId: selectedService.serviceId,
            page: page,
            size: listSize,
            sortField: [sortModel.field],
            sortOrder: [sortModel.sort],
        };

        await axios.post(groupUsersAll, params)
            .then((res) => {


                //배열을 map/JSON 방식으로 복사하여 완전히 새 객체로 만들어야 서로 영향을 주지 않습니다.
                // setOriginalGroupUsers(pageAuthRes.data.data.map(item => ({ ...item })));
                setSelectedGroupUsers(res.data.data.map(item => ({ ...item })));

                const selectedNode = findNodeByKey(treeData, String(id));
                
                if (selectedNode) {
                    setTotalCount(selectedNode.userCount);
                } else {
                    setTotalCount(0);
                }
            })
            .catch((e) => {
                showDialog({
                    iconType: "warning",
                    type: 'error',
                    title: "실패",
                    message: "사용자 정보 조회에 실패했습니다.",
                    confirmText: "확인",
                });
            })
            .finally(() => {
                setUsersLoading(false);
            });
    };

    const findNodeByKey = (nodes, key) => {
        for (const node of nodes) {
            // 현재 노드의 키가 일치하는지 확인
            if (node.key === key) {
                return node; // 찾았으면 해당 노드를 반환
            }
            // 현재 노드에 자식이 있다면, 자식 배열에 대해 재귀적으로 함수 호출
            if (node.children && node.children.length > 0) {
                const found = findNodeByKey(node.children, key);
                if (found) {
                    return found; // 자식 노드에서 찾았으면 그 결과를 반환
                }
            }
        }
        // 전체를 다 찾아봤는데도 없으면 null 반환
        return null;
    };

    // 권한만 다시 가져오는 함수
    const reloadGoupUsres = (id) => {
        // 1. 유저 테이블 갱신
        getGroupUsersAll(id);
        // 2. 트리도 갱신
        fetchData(id);
    }

    // 그룹 유저 추가 모달 핸들러
    const handleAddGroupUsers = () => {
        showInnocodeModal({
            enableDefaultStyle: true,
            enableMobileFullScreen: false,
            headerBuilder: () => { return <></>; },
            contentBuilder: (
                _data,
                _handleSave,
                _handleDelete,
                _handleUpdate,
                handleClose,
                _modalType
            ) => {
                return <GroupUserRegisterModal
                        selectedServiceId={selectedService.serviceId}
                        groupId={selectedGroup.key}
                        update={reloadGoupUsres}  
                        onClose={handleClose} />;
            },
        });


        // const modalContent = <GroupUserRegisterModal update={reloadGoupUsres} 
        //     selectedServiceId={selectedService.serviceId} groupId={selectedGroup.key}/>
        // const modalOption = {modalTitle: '유저 추가'}
        // openModal(<DetailModal content={modalContent} option={modalOption} className={styles.widePopCont}/>)
    };

    // 그룹 유저 삭제
    const handleDeleteGroupUsers = (selectedIds) => {
        if(selectedGroup.key === "0"){
            showDialog({
                iconType: "warning",
                type: 'info',
                title: "알림",
                message: "미지정 그룹에서는 제거 할 수 없습니다.",
                confirmText: "확인",
            });
            return;
        }

        showDialog({
            iconType: "warning",
            type: 'delete',
            title: "제거",
            message: "유저를 그룹에서 제외 시키겠습니까?",
            confirmText: "예",
            cancelText: "아니요",
            onConfirm: () => {
                Promise.all([
                    ...(selectedIds.length > 0 ? [
                        axios.post(`${IAM_SERVER_SERVICE_GROUP}/delete/${selectedGroup.key}/users`, {
                            serviceId: selectedService.serviceId,
                            userIds: selectedIds
                        })
                    ] : []),
                ])
                .then(() => {
                    reloadGoupUsres(selectedGroup.key);
                })
                .catch(err => {
                    showDialog({
                        iconType: "warning",
                        type: 'error',
                        title: "실패",
                        message: err.response?.data?.message || "저장 실패",
                        confirmText: "확인",
                    });
                });
            },
        });
    };

    // 페이지 상세정보 모달 핸들러
    const handleDetailInfo = (node) => {
        const modalContent = <GroupDetailModal id={node.key} update={fetchData}/>
        const modalOption = {modalTitle: '그룹 정보'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // 재귀적으로 트리 노드를 렌더링하는 함수
    const renderTreeNode = (node, level = 0) => { 
        const hasChildren = node.children && node.children.length > 0;
        const isExpanded = expandedNodes[node.key];
        const isSelected = selectedGroup?.key === node.key;

        return (
            <div key={node.key} style={{ marginLeft: level > 0 ? '33px' : '0' }}>
                <InnocodeList
                    size="sm"
                    className={`${styles.treeNode} ${isSelected ? styles.selected : ''}`}
                    onClick={() => handleSelect(node)}
                    leadingIcon={hasChildren}
                    trailingIcon={true}
                >
                    {hasChildren && (
                        <div 
                            slot="leading-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand(node.key);
                            }}
                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                        >
                            {isExpanded ? 
                             <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                             <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                           </svg>
                            : 
                                <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                              </svg>
                            }
                        </div>
                    )}
                    
                    <span className={styles.treeName}>{node.title}</span> 
                    {(level === 0  && node.title !== "미지정") && ( 
                    <InnocodeButton
                    size="sm"
                    slot="trailing-icon" 
                    iconOnly={true}
                    theme={"opacity"}
                    designType="assistive" 
                    enablePadding={false}
                    icon={ <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14m-7 7V5"/>
                    </svg>
                    }
                    onClick={(e) => onAddGroup(node, e)}   
                  ></InnocodeButton>)}
                  {
                    (node.title !== "미지정") && ( 
                        <InnocodeButton
                        size="sm"
                        slot="trailing-icon" 
                        iconOnly={true}
                        theme={"opacity"}
                        designType="assistive" 
                        enablePadding={false}
                        icon={ <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"/>
                        </svg> }
                        onClick={(e) => handleDetailClick(node, e)}   
                        ></InnocodeButton>
                    )
                  } 
                </InnocodeList>
                
                {/* children 렌더링 */}
                {hasChildren && isExpanded && (
                    <div className={styles.treeChildren}>
                        {node.children.map(child => renderTreeNode(child, level + 1))}
                    </div>
                )}
            </div>
        );
    };

    const onAddGroup = (node) => {
        const groupId = node?.key || "0";
        const modalContent = (
            <GroupRegisterModal
                update={fetchData}
                selectedServiceId={selectedService.serviceId}
                groupData={treeData}
                selectedGroupId={groupId}
            />
        );
        const modalOption = {modalTitle: '그룹 등록'}
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    // page 또는 정렬 조건이 바뀔 때마다 Reloading
    useEffect(() => {
        if(selectedGroup){
            getGroupUsersAll(selectedGroup.key, page, listSize,);
        }
    }, [page]);

    const handleSortChange = (field) => {
        setSortModel(prevSortModel => {
            const isAsc = prevSortModel.field === field && prevSortModel.sort === 'asc';
            return {
                field: field,
                sort: isAsc ? 'desc' : 'asc'
            };
        });
    };
    
    useEffect(() => {
        if (selectedGroup) {
            setPage(0);
            getGroupUsersAll(selectedGroup.key, 0, listSize);
        }
    }, [sortModel]); // sortModel이 바뀔 때마다 실행

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };

    return (
        <div className={styles.layoutWrapper}>
            <h3>그룹 관리</h3>

            <div className={styles.contentsWrapper}> 
                {showGroupTree && (
                    <div className={styles.sidebar}
                        style={{ 
                            marginRight: "10px",
                            width: !isMobileWindow ? "280px" : "120px",
                            minWidth: !isMobileWindow ? "250px" : "100px"
                        }}
                    >
                        <div className={styles.addButtonWrapper}>
                            <InnocodeButton
                                size="md" 
                                theme={"line"}
                                designType="primary"
                                onClick={onAddGroup} 
                            >
                                그룹 등록
                            </InnocodeButton>
                        </div>
                        <div className={styles.treeWrapper}>
                            {treeData.map(node => renderTreeNode(node))}
                        </div> 
                    </div>
                )}
                <div className={styles.contentBox}>
                    <div className={styles.permissionPanel}>
                        {selectedGroup ? (
                            <div>
                            {usersLoading 
                                ? <Loading/>
                                : 
                                <GroupUsersTable
                                    groupId={selectedGroup.key} 
                                    datas={selectedGroupUsers}
                                    context={context}
                                    onAddUser={handleAddGroupUsers}
                                    onDeleteUsers={handleDeleteGroupUsers}
                                    onPrevPage={handlePrevPage}
                                    onNextPage={handleNextPage}
                                    disablePrev={page === 0}
                                    disableNext={(page + 1) * listSize >= totalCount}
                                    pageNumber={page}
                                    totalCount={totalCount}
                                    listSize={listSize}
                                    sortField={sortModel.field}
                                    sortOrder={sortModel.sort}
                                    onSortChange={handleSortChange}
                                    isMobileWindow={isMobileWindow}
                                />
                            }
                            </div>
                        ) : (
                            <div className={styles.emptyState}>
                                <p>그룹을 선택해주세요</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Group;